import { AfterViewInit, Component, OnInit, ElementRef, Input, Inject, ViewChild, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { routerTransition } from '../_animations/index';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { KeypadComponent } from '../keypad/keypad.component';
import { InfodialogComponent } from '../infodialog/infodialog.component';
import { GifdialogComponent } from '../gifdialog/gifdialog.component';
import * as THREE from 'three-full';
import { EffectComposer, BokehPass, SMAAPass, OutlinePass, FilmPass, ShaderPass, RenderPass } from "postprocessing";
import * as TWEEN from "@tweenjs/tween.js";
import "./js/EnableTween";

@Component({
  selector: 'hplc2',
  templateUrl: './hplc2.component.html',
  styleUrls: ['./hplc2.component.css'],
  animations: [routerTransition],
  host: { '[@routerTransition]': '' }
})

export class Hplc2Component implements AfterViewInit {
  public router: Router
  public hplcChoice = "Click on the machine below."
  public output:String = "Output"
  public hplcDef = "";

  private renderer: THREE.WebGLRenderer;
  private camera: THREE.CinematicCamera;
  // private camera: THREE.PerspectiveCamera;
  public scene: THREE.Scene;
  //Not sure COMPOSER needs THREE
  public composer: THREE.EffectComposer;
  public pulsate: THREE.Vector3;
  private cameraTarget: THREE.Vector3;
  public hplc2: THREE.Object3D; //Use hplc2 for postprocessing effects (selectedObject)
  public outlinePass: OutlinePass;
  public controls: THREE.OrbitControls;
  public renderPass: THREE.RenderPass;
  public shaderPass: THREE.ShaderPass;
  public smaaPass: SMAAPass;
  public bokehPass: BokehPass;
  public raycaster: THREE.Raycaster;
  public clock = new THREE.Clock();

  public fieldOfView: number = 13;
  // public aspectRatio: number = 13;
  public farClippingPane: number = 1100;
  public nearClippingPane: number = 1;
  public zoom: number = 5;
  public machinesize: number = 0.1;
  public myrotate: number = 0;

  public sendOut : any;
  public makeVisible : any;
  public openDoor : any;
  public reset : any;
  public getTarget : any;
  public getPosition : any;
  public opened : boolean;
  public stepone : boolean;
  public steptwo : boolean;
  public stepthree : boolean;
  public stepfour : boolean;
  public stepfive : boolean;
  public completed : boolean = false;
  public inspect : any;
  public turn : any;
  public toggleControls : any;
  public toggleinstructions:boolean=false;

  //Advance through list of instructions
  public advance : any =
       function() {
        console.log(this.taskindex);
        if (this.taskindex<this.taskprogress.length-1) {
          this.taskindex++;
      } else if (this.taskindex==this.taskprogress.length) {
        this.output="Injections";
        this.openDialog(); }
      else { null; }
      }

  public checkedSolvents : boolean;

  public animNum: number;

  public navigable: Boolean = false;
  // public bokeh: BokehShader;
  // public bokehPass: BokehPass;

  public pulse : TWEEN;
  public sphereopacity: TWEEN;

  public CANVAS_HEIGHT = 1280;
  public CANVAS_WIDTH = 1280;

  public taskprogress: any = ["Check solvent line","Purge pump","Purge autosampler","Condition (equilibriate) the column", "Turn on the pump", "Switch to software interface"];
  public taskindex: number=0;

  @ViewChild('canvas')
  private canvasRef: ElementRef;

  constructor( public dialog: MatDialog ) {
      // console.log("TWEEN = ",this.pulse);
      this.render = this.render.bind(this);
      this.onModelLoadingCompleted = this.onModelLoadingCompleted.bind(this);
  }


        openDialog(): void {
          console.log("DIALOG OUTPUT",this.output);
          // console.log("DIALOG SENDOUT",this.sendOut);
          // this.controls.enabled = false;
          let dialogRef = this.dialog.open( InfodialogComponent, {
            width: '90%',
            hasBackdrop: true,
            panelClass: 'infoPanel',
            data: { sendout: this.sendOut, output: this.output, task:this.taskindex }
          });

          dialogRef.afterClosed().subscribe(result => {
            // this.controls.enabled = true;
            console.log('The dialog was closed');
            this.output = result;
          });
        }

        openGIF(): void {
          console.log("DIALOG OUTPUT",this.output);
          // console.log("DIALOG SENDOUT",this.sendOut);
          // this.controls.enabled = false;
            let dialogRef = this.dialog.open( GifdialogComponent, {
            width: '90%',
            hasBackdrop: true,
            panelClass: 'infoPanel',
            data: { output: this.output }
          });

          dialogRef.afterClosed().subscribe(result => {
            // this.controls.enabled = true;
            console.log('The dialog was closed');
            this.output = result;
          });
        }

        openKeypad(): void {
          console.log("DIALOG OUTPUT",this.output);
          // console.log("DIALOG SENDOUT",this.sendOut);
          // this.controls.enabled = false;
          let dialogRef = this.dialog.open( KeypadComponent, {
            width: '400px',
            hasBackdrop: true,
            panelClass: 'keypad',
            data: { sendout: this.sendOut, output: this.output }
          });

          dialogRef.afterClosed().subscribe(result => {
            // this.controls.enabled = true;
            console.log('The dialog was closed');
            this.output = result;
          });
        }

  private get canvas(): HTMLCanvasElement {
      return this.canvasRef.nativeElement;
  }

  private createScene() {
      // console.log("outlinepass",this.outlinePass);
      this.scene = new THREE.Scene();
      // var bokeh_shader = BokehShader;
      // this.scene.fog = new THREE.FogExp2( 0x336699, .006 ); //affects the model only
      this.opened = false;
      this.stepone = true;
      this.steptwo = true;
      this.stepthree = true;
      this.stepfour = true;
      this.stepfive = true;
      this.checkedSolvents = false;
      // this.scene.add(new THREE.AxisHelper(200));
      //load HPLC machine--------
      var loader = new THREE.ObjectLoader();
      loader.load('assets/models/autosampler_binary.json', this.onModelLoadingCompleted);
  }

  private onModelLoadingCompleted(collada) {
    // console.log("COLLADA", collada);
      this.remove('progress');
      var modelScene = collada;
      modelScene.scale.set(1,1,1);
      modelScene.position.set(0,-25,-20);
      modelScene.rotation.set(0,0,0);
      modelScene.name="machine";
      this.scene.add(modelScene);
      this.scene.remove(this.scene.getObjectByName("PointLight"));
      var numbers = ["FLOATINGICONNUMBER1", "FLOATINGICONNUMBER2", "FLOATINGICONNUMBER3", "FLOATINGICONNUMBER4", "FLOATINGICONNUMBER5"]
        for (let entry of numbers) {
            var myNumber = this.scene.getObjectByName(entry);
            myNumber.visible = false;
            myNumber.material.transparent = true;
        }
        this.scene.getObjectByName("FLOATINGICONNUMBER1").visible=true;
      //   this.scene.getObjectByName("FLOATINGICONNUMBER2").position.y = this.scene.getObjectByName("FLOATINGICONNUMBER2").position.y+0.3;
      //   this.scene.getObjectByName("FLOATINGICONNUMBER2").position.x = this.scene.getObjectByName("FLOATINGICONNUMBER2").position.x+0.8;
      this.render();

  }

  private createLight() {
      var light = new THREE.PointLight(0xffffff, 0.5, 1000);
      light.position.set(-10, -1, -5);
      this.scene.add(light);
  }

  private createCamera() {
      this.camera = new THREE.PerspectiveCamera( 60, window.innerWidth / window.innerHeight, 1, 1000 );
				// this.camera.setLens( 100 );

      // Set position and look at
      this.camera.position.set(0,5,50);
      // this.camera.lookAt(this.scene.getObjectByName("PlasticDivider_2").position);
  }

  private getAspectRatio(): number {
      let height = this.canvas.clientHeight;
      if (height === 0) {
          return 0;
      }

      return this.canvas.clientWidth / this.canvas.clientHeight;
  }

  private startRendering() {
    this.renderer = new THREE.WebGLRenderer({
        canvas: this.canvas,
        precision: "highp",
        antialias: true,
        logarithmicDepthBuffer: true,
        alpha: true
    });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight, false);
    // this.renderer.setSize( this.CANVAS_WIDTH, this.CANVAS_HEIGHT );
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    this.renderer.setClearColor(0x151515, 0.2);
    this.renderer.autoClear = true;

    this.canvas.style.width = "100%";
    this.canvas.style.height = "auto";
    this.camera.aspect = this.getAspectRatio();
    this.camera.updateProjectionMatrix();

    //POSTPROCESSING POSTPROCESSING
    this.composer = new THREE.EffectComposer( this.renderer );
    this.composer.addPass( new THREE.RenderPass( this.scene, this.camera ) );

    console.log("FINISHED SETTING UP COMPOSER");
    // console.log("COMPOSER EFFECT", effect);
    console.log("COMPOSER", this.composer);
    console.log("CAMERA", this.camera);
    console.log("SCENE", this.scene.children);

    //POSTPROCESSING POSTPROCESSING

      this.animNum=1;

      // this.hplc2 = this.scene.getObjectByName("hplc2");
    function updateanimation() {
      console.log("updateanimation", this.animNum);

      // this.scene.getObjectByName("hplc2").position.y = .75 + Math.cos(this.animNum/3)*.25;
      this.animNum += 0.16;
    }

      let component: Hplc2Component = this;

      (function render() {
          TWEEN.update();
          requestAnimationFrame(render);
          component.render();
      }());
  }


  public render() {

          this.renderer.clear();
      // console.log("mycamerarotation", this.camera.rotation);
      // console.log("mycameraposition", this.camera.position);
          this.renderer.render(this.scene, this.camera);
      this.composer.render();
  }

  public addControls() {
      this.controls = new THREE.OrbitControls(this.camera);
      this.controls.rotateSpeed = 1.0;
      this.controls.zoomSpeed = 1.2;
      this.controls.domElement = this.canvas;
      this.controls.minPolarAngle = 1.0;
      this.controls.maxPolarAngle = 1.5;
      this.controls.enabled = true;

      console.log("INITIAL TARGET", this.controls.target);
      this.controls.addEventListener('change', this.render);

      // this.getTarget = function(){
      //   console.log("CONTROLS TARGET", this.controls.target);
      //   this.output = String(this.controls.target);
      // };
      //
      this.getPosition = function(){
        // console.log("CAMERA POSITION", this.scene.getObjectByName("machine").position);
        // console.log("CAMERA ROTATION", this.scene.getObjectByName("machine").rotation);
        console.log("CAMERA ROTATION", this.camera.rotation);
        console.log("CAMERA POSITION", this.camera.position);
        this.output = String(this.camera.position);
      };

  }

  /* EVENTS */
  public routeTo(hplclink) {
    if (hplclink!="Clicked on the machine below." && hplclink!="Click on the machine below.") {
      this.navigable = true;
        if (hplclink=="/hplc1") {this.hplcDef="HPLC with Autosampler"}
        if (hplclink=="/hplc2") {this.hplcDef="HPLC with Manual Injector"}
        if (hplclink=="/hplc3") {this.hplcDef="UPLC with Autosampler"}

    }
  }

  public onMouseDown(event: MouseEvent) {
    console.log("onMouseDown");

    this.makeVisible = function(object) {
      console.log("CAMERA POS", this.camera.position);
      // var controlTarget = new THREE.Vector3(0,0,0);
      // var camTarget = new THREE.Vector3(77, 36, 52);
      // var moveCam = new TWEEN.Tween(this.camera.position).to(camTarget,800).start();
      // var moveTarget = new TWEEN.Tween(this.controls.target).to(controlTarget,800).start();
      var pressPos = new THREE.Vector3(-50,0,0);
      var movePress = new TWEEN.Tween(object.getObjectByName("Cube_3").position).to(pressPos,800).start();
      }

      this.toggleControls = function() {
        this.controls.enabled=!this.controls.enabled;

          // this.output = String(this.controls.target);

      }

      this.getPosition = function(){
        console.log("MACHINE POSITION", this.scene.getObjectByName("machine").position);
        console.log("MACHINE ROTATION", this.scene.getObjectByName("machine").rotation);
        console.log("CAMERA POSITION", this.camera.position);
        console.log("CAMERA ROTATION", this.camera.rotation);
        console.log("CONTROLS TARGET", this.controls.target);
        // this.output = String(this.camera.position);
      };

      this.openDoor = function(target) {
        console.log("OPENDOOR THIS OPENED",this.opened);
        var left = this.scene.getObjectByName(target);
        // var right = this.scene.getObjectByName("rightpanel");
        var startLeft = new THREE.Vector3(0,0,0);
        // var startRight = new THREE.Vector3(0,0,0);
        // var rightDoorRot = new THREE.Vector3(0,-1.5,0);
        if (target == "BOTTOMLEFT") {
        var leftDoorRot = new THREE.Vector3(0,-1.5,0);
      } else {
        var leftDoorRot = new THREE.Vector3(0,1.5,0);
      }
        // var startTray = new THREE.Vector3(-50.1173,60.6702,11.799);
        // var trayPos = new THREE.Vector3(-50.1173,60.6702,60);
        if (this.opened == false ) {
        // var opened = this.controls.enabled;
          var moveDoor = new TWEEN.Tween(left.rotation).to(leftDoorRot,800).easing(TWEEN.Easing.Exponential.InOut).start();
          // var moveDoor = new TWEEN.Tween(right.rotation).to(rightDoorRot,800).easing(TWEEN.Easing.Exponential.InOut).start();
          // var moveTray = new TWEEN.Tween(this.scene.getObjectByName("testTubes").position).easing(TWEEN.Easing.Exponential.InOut).to(trayPos,800);
          // moveDoor.chain(moveTray);
          // moveDoor.onComplete( function() { console.log(this.controls.enabled); this.controls.enabled = true; } );
        }

        if (this.opened == true ) {
          // var moveTray = new TWEEN.Tween(this.scene.getObjectByName("testTubes").position).to(startTray,800).start();
          var doors=["BOTTOMRIGHT","TOPRIGHT","TOPLEFT","BOTTOMLEFT"];
          for (let entry of doors) {
            left = this.scene.getObjectByName(entry);
            var moveDoor = new TWEEN.Tween(left.rotation).to(startLeft,800).start();
          }
          // .onStart(
            // function(){
              // new TWEEN.Tween(right.rotation).to(startRight,800).start()
            // });
          // moveTray.chain(moveDoor);
        }
        this.opened=!this.opened;
      }

    this.sendOut = function(object) {
      console.log(object.name, this.taskindex);
      var machine = this.scene.getObjectByName("machine");


      if (object.name=="FLOATINGICONNUMBER1") {
          this.taskindex=0;
          this.stepone=!this.stepone;

          this.output = "BinarySolvents";
          this.openDialog();

          this.scene.getObjectByName("FLOATINGICONNUMBER1").material.opacity = 0.5;
          this.scene.getObjectByName("FLOATINGICONNUMBER2").visible = true;
      }

      if (object.name=="FLOATINGICONNUMBER2") {
          this.taskindex=1;
          this.steptwo=!this.steptwo;

          this.output = "BinaryPump";
          this.openDialog();

          this.scene.getObjectByName("FLOATINGICONNUMBER2").material.opacity = 0.5;
          this.scene.getObjectByName("FLOATINGICONNUMBER3").visible = true;
      }

      if (object.name=="FLOATINGICONNUMBER3") {
          this.taskindex=2;
          this.stepthree=!this.stepthree;

          this.output = "Autosampler";
          this.openDialog();

          this.scene.getObjectByName("FLOATINGICONNUMBER3").material.opacity = 0.5;
          this.scene.getObjectByName("FLOATINGICONNUMBER4").visible = true;
      }

      if (object.name=="FLOATINGICONNUMBER4") {
          this.output = "Column";
          this.openDialog();

          this.taskindex=3;
          this.stepfour=!this.stepfour;

          this.scene.getObjectByName("FLOATINGICONNUMBER4").material.opacity = 0.5;
          this.scene.getObjectByName("FLOATINGICONNUMBER5").visible = true;
      }

      if (object.name=="FLOATINGICONNUMBER5") {
          this.output = "BinaryColumn";
          this.openDialog();

          this.completed=true;

          this.taskindex=4;
          this.toggleinstructions=!this.toggleinstructions;
          this.stepfive=!this.stepfive;
      }

      if (object.name=="FloatingIconOpen") {
          // if (this.taskindex==0) {
            // this.taskindex=this.taskindex+1;
            this.openDoor("TOPRIGHT");
            // this.toggleControls();
            // var mycamerarotation = this.camera.rotation;
            // var mycameraposition = this.camera.position;
            // console.log("BEFORE CAMERA POSITION", mycameraposition );
            // console.log("BEFORE CAMERA ROTATION", mycamerarotation );
            // var tilted = new THREE.Vector3(-43.503780961014996,7.108756659579556,56.17594074243722);
            // var camRot = new THREE.Vector3(-0.3260549825928141,-0.7446616456578103,-0.22526446518455354);
            // var zoomIn = new TWEEN.Tween(mycameraposition).to(tilted,800).onStart( function(){ new TWEEN.Tween(mycamerarotation).to(camRot,800).start() } ).start();
          // }
      }

      if (object.name=="FloatingIconOpen_2") {
          // if (this.taskindex==0) {
            // this.taskindex=this.taskindex+1;
            this.openDoor("BOTTOMLEFT");
            // this.toggleControls();
            // var mycamerarotation = this.camera.rotation;
            // var mycameraposition = this.camera.position;
            // console.log("BEFORE CAMERA POSITION", mycameraposition );
            // console.log("BEFORE CAMERA ROTATION", mycamerarotation );
            // var tilted = new THREE.Vector3(-37.50462788862874,8.527646957537524,32.096644260435816);
            // var camRot = new THREE.Vector3( -0.12318881760992652,-0.7695131055401754, -0.0859370532437261);
            // var zoomIn = new TWEEN.Tween(mycameraposition).to(tilted,800).onStart( function(){ new TWEEN.Tween(mycamerarotation).to(camRot,800).start() } ).start();
          // }
      }

      if (object.name=="FloatingIconOpen_3") {
          // if (this.taskindex==0) {
            // this.taskindex=this.taskindex+1;
            this.openDoor("TOPLEFT");
            // this.toggleControls();
            // var mycamerarotation = this.camera.rotation;
            // var mycameraposition = this.camera.position;
            // console.log("BEFORE CAMERA POSITION", mycameraposition );
            // console.log("BEFORE CAMERA ROTATION", mycamerarotation );
            // var tilted = new THREE.Vector3(0.9873660480685267,10.95570785581962,36.97965622856334);
            // var camRot = new THREE.Vector3(-0.17993065675810704,-0.22491501515649523,-0.040545275235548225);
            // var zoomIn = new TWEEN.Tween(mycameraposition).to(tilted,800).onStart( function(){ new TWEEN.Tween(mycamerarotation).to(camRot,800).start() } ).start();
          // }
      }

      if (object.name=="FloatingIconOpen_1") {
          // if (this.taskindex==0) {
            // this.taskindex=this.taskindex+1;
            this.openDoor("BOTTOMRIGHT");
            // this.toggleControls();
            // var mycamerarotation = this.camera.rotation;
            // var mycameraposition = this.camera.position;
            // console.log("BEFORE CAMERA POSITION", mycameraposition );
            // console.log("BEFORE CAMERA ROTATION", mycamerarotation );
            // // var tilted = new THREE.Vector3(-23.17302219729468,-12.141561509674064,41.706607189074546);
            // // var camRot = new THREE.Vector3(-0.077, -0.38,-0.028);
            // var tilted = new THREE.Vector3(39.26480896944335, 23.55849628511557,45.31067888767171);
            // var camRot = new THREE.Vector3(-0.6933613298608791,0.7215143472946032,0.501995217758616);
            // var zoomIn = new TWEEN.Tween(mycameraposition).to(tilted,800).onStart( function(){ new TWEEN.Tween(mycamerarotation).to(camRot,800).start() } ).start();
          // }
      }



      if (object.name=="FloatingIconSinglePump") {
            // if (this.taskindex==1) {
              // this.taskindex=this.taskindex+1;
              this.output = "DualReciprocatingPump";
              this.openGIF();
          // }
      }

      if (object.name=="FloatingIconChromatogram" ) {
            // if (this.taskindex==2) {
            this.output = "ChromaColumn";
            this.openGIF();
            // }
      }

      if (object.name=="FloatingIconAutosampler" ) {
            // if (this.taskindex==2) {
            this.output = "Valve";
            this.openGIF();
            // }
      }

      if (object.name=="FloatingIconColumn" ) {
            // if (this.taskindex==2) {
            this.output = "ChromaColumn";
            this.openGIF();
            // }
      }

      if (object.name=="FloatingIconClose" || object.name=="FloatingIconClose_2" || object.name=="FloatingIconClose_3" || object.name=="FloatingIconClose_1") {
            // if (this.taskindex==3) {
              // this.taskindex=this.taskindex+1;
              this.openDoor();
              // this.toggleControls();
              // var camPos = new THREE.Vector3(0,5,50);
              // var camRot = new THREE.Vector3(-0.15,0,0);
              // var mycamerarotation = this.camera.rotation;
              // var mycameraposition = this.camera.position;
              // console.log(mycameraposition, mycamerarotation, camPos, camRot);
              // var myZoomIn = new TWEEN.Tween(mycameraposition).to(camPos,800).onStart( function(){ new TWEEN.Tween(mycamerarotation).to(camRot,800).start() } ).start();
            // }
      }


      {
        this.output = object.name;
        // console.log(object.position);
        // this.scene.getObjectByName("syringe").visible=false;
        // this.scene.getObjectByName("press").position.set(0,-110,0);
      }
    }

      // console.log(this.renderer.domElement);
      event.preventDefault();

      // Example of mesh selection/pick:
      var raycaster = new THREE.Raycaster();
      var mouse = new THREE.Vector2();
      mouse.x = (event.offsetX / this.renderer.domElement.clientWidth) * 2 - 1;
      mouse.y = - (event.offsetY / this.renderer.domElement.clientHeight) * 2 + 1;
      raycaster.setFromCamera(mouse, this.camera);

      var obj: THREE.Object3D[] = [];
      this.findAllObjects(obj, this.scene);
      var intersects = raycaster.intersectObjects(obj);
      console.log("Scene has " + obj.length + " objects");
      console.log(intersects.length + " intersected objects found")

      // intersects.forEach((i) => {
          // this.hplcChoice = "/"+i.object.name;
          // this.routeTo(this.hplcChoice);
          this.sendOut(intersects[0].object); // do what you want to do with object
      // });

      // intersects.forEach((i) => {
      //     this.hplcChoice = "/"+i.object.name;
      //     // this.routeTo(this.hplcChoice);
      //     this.sendOut(i.object); // do what you want to do with object
      // });

  }

  private findAllObjects(pred: THREE.Object3D[], parent: THREE.Object3D) {
      // NOTE: Better to keep separate array of selected objects
      if (parent.children.length > 0) {
          parent.children.forEach((i) => {
              // if (i.object.name=="line") { this.hplcChoice == "Checked line -- olay line animation"}
              pred.push(i);
              this.findAllObjects(pred, i);
          });
      }
  }

  public onMouseUp(event: MouseEvent) {
      console.log("onMouseUp");
  }

  public remove (id) {
        var elem = document.getElementById(id);
        return elem.parentNode.removeChild(elem);
      }

  @HostListener('window:resize', ['$event'])
  public onResize(event: Event) {
      // this.canvas.style.width = "100%";
      // this.canvas.style.height = "auto";

      console.log("onResize: " + this.canvas.clientWidth + ", " + this.canvas.clientHeight);

      this.camera.aspect = this.getAspectRatio();
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight,false);
      this.render();
  }

  @HostListener('document:keypress', ['$event'])
  public onKeyPress(event: KeyboardEvent) {
      console.log("onKeyPress: " + event.key);
  }

  /* LIFECYCLE */
  ngAfterViewInit() {
      this.createScene();
      // this.createLight();
      this.createCamera();
      // this.createComposer();
      this.startRendering();
      this.addControls();

  }
}
